import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LanguagePreviewPanelComponent } from './components/language-preview-panel/language-preview-panel.component';

@NgModule({
    declarations: [
        LanguagePreviewPanelComponent
    ],
    imports: [
        CommonModule,
        NgSelectModule,
        FormsModule
    ],
    exports: [
        LanguagePreviewPanelComponent
    ]
})
export class PanelsModule {}
